  import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Modal,Collapse,Popconfirm, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message   } from 'antd';
import {  EditOutlined,SafetyCertificateOutlined,DeleteOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			checkedBoxes: [],
			school_list: [],
			program_list: [],
			academic_year_: [],
			total_self: 0,
			total_franchise: 0,
			is_show: 0,
			aToken: '',
			main_menu: '',
			sub_menu: '',
			academic_year: '',
			student_type: '',
			name: '',
			total_count:0,
			program_id:'',
			is_transport:'',
			page: 1,
			archive_visible:false,
			archive_reason:'',
			docs_visible: false,
		}
		this.onChangePage = this.onChangePage.bind(this);
		this.change_year = this.change_year.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.inputChange = this.inputChange.bind(this);
	}
	
	inputChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	}
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					//academic_year : new_acad,
				});
			}, 50);
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
				this.setState({program_id: program_id});
			}
			if(params.name && params.name != null){
				var name = params.name;
				this.setState({name: name});
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
				this.setState({student_type: student_type});
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
				this.setState({academic_year: academic_year});
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
				this.setState({admission_form: admission_form});
			}if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
				this.setState({is_transport: is_transport});
			}
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
							academic_year : result['current_year'],
						});
						setTimeout(() => {
							this.checkData();
						}, 500);
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});	
		getData('erp/new_program_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					setTimeout(() => {
						this.setState({
							program_list: result['data'],
						});
					}, 100);	
				}else{
					this.setState({
						program_list: [],
						
					});
				}
				}
			});
			setTimeout(() => {
				//this.checkData();
			}, 100);
	}
	
	openQuantity(e){
		this.setState({ program_id: e.target.value });
	}  
	
	handleSubmit(e){
		setTimeout(() => {
			let params = '?student_type='+this.state.student_type+'&academic_year='+this.state.academic_year+'&program_id='+this.state.program_id+'&admission_form='+this.state.admission_form+'&name='+this.state.name+'&is_transport='+this.state.is_transport;
			document.location.search = params;
			this.setState({ page: 1 });
			this.checkData();
		}, 50);
	} 

	SendLink(e){
		if(localStorage.getItem('schoolData')){
			var app = {id : e}
			getData('erp/send_payment_link_student',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					message.config({ top: 150});
					message.success('Link Send Successfully !!',2);
				}else{
					message.config({ top: 150});
					message.error('Link Not Send !!',2);
				}
			});
		}
	} 	

	AdmissionApprove(e){
		if(localStorage.getItem('schoolData')){
			var app = {id : e,user_id : this.state.user_id,school_id:this.state.school_id}
			getData('erp/approve_admission',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					message.config({ top: 150});
					message.success('Admission Approved Successfully !!',2);
					setTimeout(() => {
						this.checkData();
					}, 100);
				}else{
					message.config({ top: 150});
					message.error('Admission Not Approved !!',2);
				}
			});
		}
	} 	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
			}else{
				var program_id = this.state.program_id;
			}
			if(params.name && params.name != null){
				var name = params.name;
			}else{
				var name = this.state.name;
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
			}else{
				var student_type = this.state.student_type;
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
			}else{
				var academic_year = this.state.academic_year;
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
			}else{
				var admission_form = this.state.admission_form;
			}
			if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
			}else{
				var is_transport = this.state.is_transport;
			}
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,program_id:program_id,name:name,student_type:student_type,academic_year:academic_year,admission_form:admission_form,is_transport:is_transport}
			getData('erp/pending_children_profile_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_count: result['total_school'],
							is_show: 1,
						});
					}else{
						this.setState({
							school_list: [],
							total_count: 0,
							is_show: 1,
						});
					}
				}
			});
	}
    }
	
	change_year(event){
	this.setState({academic_year: event.target.value});
	}
	change_type(event){
	this.setState({student_type: event.target.value});
	}
	change_admission_form(event){
	this.setState({admission_form: event.target.value});
	}
	change_is_transport(event){
	this.setState({is_transport: event.target.value});
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true});
		console.log(checkedBoxes);
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
	handleCheckbox = (e, s) => {
		const checkedBoxes = [...this.state.checkedBoxes];
		if(e.target.checked) {
			checkedBoxes.push(s)
		} else {
			const index = checkedBoxes.findIndex((ch) => ch === s);
			checkedBoxes.splice(index, 1);
		}
		this.setState({checkedBoxes,selection_count:checkedBoxes.length});
	}
	
	deletedata = () => {
		if(this.state.checkedBoxes.length>0){
			if(this.state.archive_reason !=''){
				var app = {user_id : this.state.user_id,id:this.state.checkedBoxes,school_id:this.state.school_id,archive_reason:this.state.archive_reason}
				getData('erp/student_delete',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							this.setState({
								marketing_delete: result['data'],
							});
							this.checkData();
							message.config({ top: 150});
							this.setState({checkedBoxes:[],archive_reason : '',archive_visible:false});
							message.success('Archive Request Submitted Successfully',2);
						}else{
							this.setState({
								marketing_delete: [],
							});
						}
					}
				});
			}else{
				message.config({ top: 150});
				message.error('Please Enter Remark',2);
			}
			
		}
		else{
			message.config({ top: 150});
			message.error('Please select Student',2);
		}
	};
	
	showArchive = () => {		
		if(this.state.checkedBoxes.length>0){
			this.setState({
				archive_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select Student',2);
		}
	}

	handleArchive = e => {
		this.setState({
			archive_visible: false,
		})
	}	
	
	showdocs = () => {
		this.setState({
			docs_visible: true,
		})
	}
	
	
	handledocsOk = e => {
		this.setState({
			docs_visible: false,
		})
	}

	handledocsCancel = e => {
		this.setState({
			docs_visible: false,
		})
	}
  

	render()

	{
	const {aToken}=this.state;
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<>
				<Modal
				 title="Download Document"
				 visible={this.state.docs_visible}
				 className="send-sms"
				 onOk={this.handledocsOk}
				 onCancel={this.handledocsCancel}
				>
					<div class="row">
						<div class="col col-md-12 s12 p-1 mb-20 mt-20 ">
							<table class="table table-striped table-bordered table-hover">
								<thead>
									<tr>	
										<td>Document Name</td>
										<td>Action</td>
									</tr>
								</thead>
								<tbody>
									<tr>	
										<td>For Special Needs Child</td>
										<td><a href="https://kcisapi.kidzonia.co.in/v1/uploads/docs/1_kcis_special_child.pdf" target="_blank" className="btn btn-primary new-btn mb-0"> View </a></td>
									</tr>
									<tr>	
										<td>For Age Criteria as per NEP2020</td>
										<td><a href="https://kcisapi.kidzonia.co.in/v1/uploads/docs/2_kcis_age_criteria.pdf" target="_blank" className="btn btn-primary new-btn mb-0"> View </a></td>
									</tr>
									<tr>	
										<td>For A Shadow Teacher</td>
										<td><a href="https://kcisapi.kidzonia.co.in/v1/uploads/docs/3_kcis_shadow_teacher.pdf" target="_blank" className="btn btn-primary new-btn mb-0"> View </a></td>
									</tr>
									<tr>	
										<td>For Medical Condition</td>
										<td><a href="https://kcisapi.kidzonia.co.in/v1/uploads/docs/4_kcis_medical_condition.pdf" target="_blank" className="btn btn-primary new-btn mb-0"> View </a></td>
									</tr>
									<tr>	
										<td>Fee Consession for Staff</td>
										<td><a href="https://kcisapi.kidzonia.co.in/v1/uploads/docs/fee_consession_staff.pdf" target="_blank" className="btn btn-primary new-btn mb-0"> View </a></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</Modal>
				
				<Modal
				 title="Archive Reason"
				 visible={this.state.archive_visible}
				 className="send-sms"
				 onCancel={this.handleArchive}
				>
				
				
				<div class="col col-md-12 s12 no-padd">
				  <label >Reason</label>
				  <TextArea
					  placeholder="Your Text Goes Here !!"
					  autoSize={{ minRows: 2, maxRows: 6 }}
					  name="archive_reason"
					  value={this.state.archive_reason}
					  onChange={this.inputChange}
					/>
				</div>
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.deletedata.bind(this)} loading={this.state.loading}>Submit</Button>
				</div>
				</Modal>
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Admission In Process
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Admission In Process </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>	
				
				<div class="row">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						
						<div class="row">
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Academic Year</b></label>
								<select  onChange={this.change_year} className="form-control changeSchool" value={this.state.academic_year}>
									{this.state.academic_year_.map((list) => (
										<option value={list.name}>{list.name}</option>
									))}
								</select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Class</b></label>
								 <select  placeholder="Select Class" value={this.state.program_id} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.openQuantity.bind(this)}>
									<option value=''>All</option>
									{this.state.program_list.map((list)=>(
										<option value={list.id}>{list.name}</option>
									))}	
								 </select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Student Type</b></label>
								 <select  placeholder="Student Type" value={this.state.student_type} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.change_type.bind(this)}>
									<option value="">All</option>
									<option value="Online">Online</option>
									<option value="Offline">Offline</option>
								 </select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Transport</b></label>
								 <select  placeholder="Admission Form" value={this.state.is_transport} name="admission_form" id="admission_form" className="form-control changeSchool" onChange={this.change_is_transport.bind(this)}>
									<option value="">All</option>
									<option value="1">Yes</option>
									<option value="0">No</option>
								 </select>
							</div>
						</div>
						<div class="col-md-2 hidden">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Admission Form</b></label>
								 <select  placeholder="Admission Form" value={this.state.admission_form} name="admission_form" id="admission_form" className="form-control changeSchool" onChange={this.change_admission_form.bind(this)}>
									<option value="">All</option>
									<option value="1">Submitted</option>
									<option value="0">Not Submitted</option>
								 </select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Student Name</b></label>
								 <input type="text" class="form-control" name="name" placeholder="Search Student" onChange={this.handleSizeChange}/>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}>&nbsp;</label>
								 <Button className="btn btn-primary mr-2" style={{display: 'block'}} id="submit_btn" onClick={this.handleSubmit.bind(this)} >Apply</Button>
							</div>
						</div>
						
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3">
					 <div class="card">
						<div class="card-body">
						<div class="row mb-10">
						<div class="col-sm-4 col-12 text-left  enquiry-btn mt-10">
							<h4 class="header-title mt-5px">Total Child : {this.state.total_count}</h4>
						</div>
						<div class="col-sm-8 col-12 text-right  enquiry-btn mt-5px">
						
							<button onClick={this.showdocs} type="button" className="btn btn-primary new-btn "> Download Document</button>
							
							{this.state.user_type == 'admin' && (<>
							<Popconfirm
									title="Are you sure you want to archive?"
									onConfirm={this.showArchive}
									okText="Yes"
									cancelText="No"
								  >
									<button className="btn btn-primary new-btn mr-1 right" style={{display: 'block'}}><DeleteOutlined /> Archive</button>
						   </Popconfirm>
							</>)}	
						</div>
						</div>
						
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
									<th>
									{(() => {
										if (this.state.checked==true) {
											return (
												<>
												<Checkbox  
													onClick={this.toggleUnChecked.bind(this)}
													checked="checked"
												>
												</Checkbox>
												</>
											)
										}
										else{
											return (
												<>
												<Checkbox  
													onClick={this.toggleChecked.bind(this)}
													checked=""
												>
												</Checkbox>
												</>
											)
										}
									})()}
									</th>
                                    <th>#</th>
                                    <th>Name</th>
									<th>Class</th>
									<th>Division</th>
									<th>Gender</th>
									<th>Type</th>
									<th>Emergency</th>
									<th>Admission Form</th>
									<th>Document</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {(this.state.school_list.length == 0 && this.state.is_show == 1) && (<><tr><td colspan="12" class="text-center">No Children Profile Found</td></tr></>)}
							  {(this.state.school_list.length == 0 && this.state.is_show == 0) && (<><tr><td colspan="12" class="text-center">Please Wait While Loading</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr>
									<td> 
									{(list.archive_req == 1) ? (
										<>
											<Checkbox  
												name="checked_id[]"
												value={list.id}
												checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
												onChange={(e) => this.handleCheckbox(e, list.id)}
												disabled
											 >
											</Checkbox>
										</>
									):(
										<>
											<Checkbox  
												name="checked_id[]"
												value={list.id}
												checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
												onChange={(e) => this.handleCheckbox(e, list.id)}
											 >
											</Checkbox>
										</>
									)}
									</td>
									<td>{index+1}</td>
                                    <td>{list.name}</td>
                                    <td>{list.program_name}</td>
                                    <td>{list.division}</td>
                                    <td>{list.gender}</td>
                                    <td>{list.type}</td>
                                    <td>{list.emergency}</td>
                                    <td>{list.admission_form == 1 ? (
									<>Submitted</>
									):(
									<>Not Submitted</>
									)}</td>
                                    <td>{list.doc_count}</td>
                                    <td>
										<div class="dropright dropright">
											<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<i class="mdi mdi-dots-vertical"></i>
											</button>
											<ul class="dropdown-menu">
												{(() => {
												if ((this.state.permission.find(element => element == 28)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<li><Link to={`${process.env.PUBLIC_URL}/student/edit/${list.id}`} class="dropdown-item"><EditOutlined /> View & Edit</Link></li>
													</>
													)
												}
												})()}
												
												<li><Link to={`${process.env.PUBLIC_URL}/student/document/${list.id}`} class="dropdown-item"><EditOutlined /> Upload Document</Link></li>
												
												
												
												{(() => {
													if ((this.state.permission.find(element => element == 27)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
														return (
														<>
												
															<li><a href={`${this.state.main_link}/assign-accessories/${list.id}?t=${aToken}`} class="dropdown-item"><EditOutlined />Assign Accessories</a></li>
														</>
														)
													}
												})()}
												
												{(() => {
													if ((this.state.permission.find(element => element == 24)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
														return (
														<>
														<li><Link to={`${process.env.PUBLIC_URL}/student/fees/${list.id}`} class="dropdown-item"><EditOutlined /> Assign Fees</Link></li>
														</>
														)
													}
												})()}
												
												{(() => {
													if ((this.state.permission.find(element => element == 33)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
														return (
														<>
														<li><Link to={`${process.env.PUBLIC_URL}/student/transport/${list.id}`} class="dropdown-item"><EditOutlined /> Assign Transport</Link></li>
														</>
														)
													}
												})()}
												
												
												
												{(() => {
													if ((this.state.permission.find(element => element == 30)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
														return (
														<>
															<li><Link to={`${process.env.PUBLIC_URL}/student/view-fees/${list.id}`} class="dropdown-item"><EditOutlined /> View Fees</Link></li>
														</>
														)
													}
												})()}
												
												{(() => {
													if ((this.state.permission.find(element => element == 29)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
														return (
														<>
															<li><Link to={`${process.env.PUBLIC_URL}/student/pay-fees/${list.id}`} class="dropdown-item"><EditOutlined /> Pay Fees</Link></li>
														</>
														)
													}
												})()}
												
												<li><span class="dropdown-item pointer" onClick={this.SendLink.bind(this,list.id)}><EditOutlined /> Send Payment Link</span></li>
												
												<li><span class="dropdown-item pointer" onClick={this.AdmissionApprove.bind(this,list.id)}><EditOutlined /> Approved To Admission</span></li>
												
											</ul>
										</div>
                                    </td>
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
						    <div class="fl-right">
								<Pagination
									activePage={this.state.page}
									itemsCountPerPage={10}
									totalItemsCount={this.state.total_count}
									pageRangeDisplayed={3}
									onChange={this.onChangePage.bind(this)}
								/>
							</div>
							{this.state.user_type == 'admin' && (<>
							<Link to={`${process.env.PUBLIC_URL}/admission/archive`} className="archive-list">Archive Admission History</Link>	
							</>)}
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
